<template>
  <div class="privacy_policy">
    <h2>隱私權政策</h2>
    <p> 金牌王國非常重視會員的隱私權且遵循「個人資料保護法」之規定，因此制訂了隱私權保護政策，您可參考下列隱私權保護政策的內容。</p>
    <div class="policies">
      <h3>個人資料之安全</h3>
      <p>保護會員的個人隱私是金牌王國重要的經營理念，在未經會員同意之下，我們絕不會將會員的個人資料提供予任何與本購物網站服務無關之第三人。會員應妥善保密自己的網路密碼及個人資料，不要將任何個人資料，尤其是網路密碼提供給任何人。在使用完金牌王國網站所提供的各項服務功能後，務必記得登出帳戶，若是與他人共享電腦或使用公共電腦，切記要關閉瀏覽器視窗。</p>
    </div>
    <div class="policies">
      <h3>個人資料的利用</h3>
      <p>金牌王國相關網站所取得的個人資料，都僅供金牌王國於其內部、依照原來所說明的使用目的和範圍，除非事先說明、或依照相關法律規定，否則金牌王國不會將資料提供給第三人、或移作其他目的使用。利用之目的例示如下：</p>
      <ol>
        <li>以會員身份使用金牌王國提供之各項服務時，於頁面中自動顯示會員資訊。</li>
        <li>為遂行交易行為：會員對商品配送、勞務提供、價金給付、回覆客戶之詢問、金牌王國對會員之詢問、相關售後服務及其他遂行交易所必要之業務。</li>
        <li>宣傳廣告或行銷等：提供會員各種電子雜誌等資訊、透過電子郵件、郵件、電話等提供與服務有關之資訊。 將會員所瀏覽之內容或廣告，依客戶之個人屬性或購買紀錄、金牌王國網站之瀏覽紀錄等項目，進行個人化作業、會員使用服務之分析、新服務之開發或既有服務之改善等。 針對民調、活動、留言版等之意見，或其他服務關連事項，與會員進行聯繫。</li>
        <li>回覆客戶之詢問：針對會員透過電子郵件、郵件、傳真、電話或其他任何直接間接聯絡方式向金牌王國所提出之詢問進行回覆。</li>
        <li>其他業務附隨之事項：附隨於上述 1. 至 4. 之利用目的而為金牌王國提供服務所必要之使用</li>
        <li>對於各別服務提供者之資訊提供：會員對服務提供者使用服務時時，金牌王國於該交易所必要之範圍內，得將會員之個人資料檔案提供予服務提供者，並由服務提供者負責管理該個人資料檔案。金牌王國將以規約課予服務提供者依保障會員隱私權之原則處理個人資料之義務，但無法保證服務提供者會必然遵守。詳細內容，請向各別服務提供者洽詢。</li>
        <li>其他：提供個別服務時，亦可能於上述規定之目的以外，利用個人資料。此時將在該個別服務之網頁載明其要旨。</li>
      </ol>
    </div>
    <div class="policies">
      <h3>資料安全</h3>
      <p>為保障會員的隱私及安全，金牌王國會員帳號資料會用密碼保護。金牌王國並盡力以合理之技術及程序，保障所有個人資料之安全。</p>
    </div>
    <div class="policies">
      <h3>Cookie</h3>
      <p>為了便利會員使用，金牌王國網站會使用cookie技術，以便於提供會員所需要的服務；cookie是網站伺服器用來和會員瀏覽器進行溝通的一種技術，它可能在會員的電腦中隨機儲存字串，用以辨識區別使用者，若會員關閉cookie有可能導致無法順利登入網站或無法使用購物車等狀況。</p>
    </div>
    <div class="policies">
      <h3>隱私權保護政策修訂</h3>
      <p>隨著市場環境的改變本公司將會不時修訂網站政策。會員如果對於金牌王國網站隱私權聲明、或與個人資料有關之相關事項有任何疑問，可以利用電子和來電和金牌王國聯絡。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy"
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.privacy_policy {
  padding: 140px 6.2% 60px 6.2%;
  padding-top: 140px;
  text-align: left;
  color: $secondaryDeepColor1;
  font-size: 17px;
  h2 {
    font-size: 35px;
    font-weight: 600;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin-top: 0;
  }
  h3 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 0;
  }
  ol {
    padding-left: 21px;
  }
  p {
    line-height: 30px;
  }
}
.policies {
  & > p:first-of-type {
    margin-top: 0;
  }
}
</style>
